import { Injectable, Inject, InjectionToken } from '@angular/core';
import { FontInfo } from 'estensa-module';
import { noop } from 'rxjs';

export const ESTENSA_MODULE_SPEECH_MODAL_SERVICE = new InjectionToken('estensa.module.speech.modal');

interface ISpeechModalServiceNg1 {
    isSpeechEngineInitialized;
    canShowMicIconOnTextEditor;
    speechWindow;

    setReconice(reconice: any): void;

    getReconice(): any;

    getEditorApi(): any;

    initSpeechEngine(): void;

    showMicIconOnTextEditor(): boolean;

    onActivateSpeechWindow(): void;

    onCloseSpeechWindow(): void;

    setTextAndStartDictation(): void;

    openSpeechWindow(textEditorId: string, speechText: string, fontInfo: FontInfo | null): void;

    addTextToEditorAndClose(): void;

    closeWindow(): void;

    registerComponentId(componentId: string): void;

    safeExit(): void;

    setSpeechSkin();

    setThemeAndColors(): void;
}

@Injectable({
    providedIn: 'root',
})
export class NullSpeechModalService implements ISpeechModalServiceNg1 {
    isSpeechEngineInitialized: any;
    canShowMicIconOnTextEditor: any;
    speechWindow: any;

    setReconice = noop;
    getReconice = noop;
    getEditorApi = noop;
    initSpeechEngine = noop;

    showMicIconOnTextEditor(): boolean {
        return false;
    }

    onActivateSpeechWindow = noop;
    onCloseSpeechWindow = noop;
    setTextAndStartDictation = noop;
    openSpeechWindow = noop;
    addTextToEditorAndClose = noop;
    closeWindow = noop;
    safeExit = noop;
    setSpeechSkin = noop;
    setThemeAndColors = noop;
    registerComponentId = noop;
}

@Injectable({
    providedIn: 'root',
})
export class EstensaSpeechModalService {
    constructor(@Inject(ESTENSA_MODULE_SPEECH_MODAL_SERVICE) private speechModalService: ISpeechModalServiceNg1) {
    }

    isSpeechEngineInitialized = this.speechModalService.isSpeechEngineInitialized;
    canShowMicIconOnTextEditor = this.speechModalService.canShowMicIconOnTextEditor;
    speechWindow = this.speechModalService.speechWindow;

    setReconice(reconice: any) {
        return this.speechModalService.setReconice(reconice);
    }

    getReconice() {
        return this.speechModalService.getReconice();
    }

    getEditorApi() {
        return this.speechModalService.getEditorApi();
    }

    initSpeechEngine() {
        return this.speechModalService.initSpeechEngine();
    }

    showMicIconOnTextEditor() {
        return this.speechModalService.showMicIconOnTextEditor();
    }

    onActivateSpeechWindow() {
        return this.speechModalService.onActivateSpeechWindow();
    }

    onCloseSpeechWindow() {
        return this.speechModalService.onCloseSpeechWindow();
    };

    setTextAndStartDictation() {
        return this.speechModalService.setTextAndStartDictation();
    };

    openSpeechWindow(textEditorId: string, speechText: string, fontInfo: FontInfo | null) {
        return this.speechModalService.openSpeechWindow(textEditorId, speechText, fontInfo);
    };

    registerComponentId(componentId: string) {
        return this.speechModalService.registerComponentId(componentId);
    }

    addTextToEditorAndClose() {
        return this.speechModalService.addTextToEditorAndClose();
    }

    closeWindow() {
        return this.speechModalService.closeWindow();
    }

    safeExit() {
        return this.speechModalService.safeExit();
    }

    setSpeechSkin() {
        return this.speechModalService.setSpeechSkin();
    }

    setThemeAndColors() {
        return this.speechModalService.setThemeAndColors();
    }
}
